import React, { useEffect, useRef } from "react";
import {
    EMBED_SUCCESS_CHECKMARK_FREEZE_MS,
    EMBED_SUCCESS_CHECKMARK_SRC,
    freezeEmbedSuccessCheckmarkSvg,
} from "./embedTicketFormTheme";

/**
 * @param {SVGSVGElement|null} root
 */
export function freezeEmbedSuccessCheckmark(root) {
    freezeEmbedSuccessCheckmarkSvg(root);
}

/**
 * @param {HTMLElement} container
 * @param {string} assetOrigin
 * @param {number} [playKey]
 */
export function appendEmbedSuccessCheckmark(container, assetOrigin, playKey = 0) {
    const origin = String(assetOrigin || "")
        .trim()
        .replace(/\/$/, "");
    if (!origin || !container) {
        return;
    }

    const obj = document.createElement("object");
    obj.type = "image/svg+xml";
    obj.data =
        origin +
        EMBED_SUCCESS_CHECKMARK_SRC +
        "?p=" +
        encodeURIComponent(String(playKey));
    obj.className =
        "claritick-ticket-embed-success-checkmark claritick-ticket-embed-success-checklist";
    obj.setAttribute("aria-hidden", "true");

    const scheduleFreeze = () => {
        const doc = obj.contentDocument;
        const root = doc && doc.documentElement;
        if (!root || root.namespaceURI !== "http://www.w3.org/2000/svg") {
            return;
        }
        window.setTimeout(() => {
            freezeEmbedSuccessCheckmark(root);
        }, EMBED_SUCCESS_CHECKMARK_FREEZE_MS);
    };

    obj.addEventListener("load", scheduleFreeze, { once: true });
    obj.onerror = function () {
        obj.remove();
    };

    container.appendChild(obj);
}

/**
 * @param {{ playKey?: number, assetOrigin?: string }} props
 */
export function EmbedSuccessCheckmark({ playKey = 0, assetOrigin = "" }) {
    const origin = String(assetOrigin || "")
        .trim()
        .replace(/\/$/, "");
    const objectRef = useRef(null);
    const timerRef = useRef(0);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
            }
        };
    }, []);

    const handleLoad = () => {
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
        }
        const obj = objectRef.current;
        const doc = obj && obj.contentDocument;
        const root = doc && doc.documentElement;
        if (!root || root.namespaceURI !== "http://www.w3.org/2000/svg") {
            return;
        }
        timerRef.current = window.setTimeout(() => {
            freezeEmbedSuccessCheckmark(root);
        }, EMBED_SUCCESS_CHECKMARK_FREEZE_MS);
    };

    if (!origin) {
        return null;
    }

    return (
        <object
            ref={objectRef}
            key={playKey}
            type="image/svg+xml"
            data={
                origin +
                EMBED_SUCCESS_CHECKMARK_SRC +
                "?p=" +
                encodeURIComponent(String(playKey))
            }
            className="claritick-ticket-embed-success-checkmark claritick-ticket-embed-success-checklist"
            aria-hidden
            onLoad={handleLoad}
        />
    );
}

export default EmbedSuccessCheckmark;
